export const WEBSITE_CTA_DESTINATION = {
  HOME: "page",
  RECEPTIONIST: "receptionist",
  RECEPTIONIST_PRICING: "receptionist:pricing",
  CONSULTATION_SESSION: "session:consultation",
  BOOKING: "booking",
  BLOG: "blog",
} as const;

export const WEBSITE_CTA_DESTINATIONS = [
  { value: WEBSITE_CTA_DESTINATION.HOME },
  { value: WEBSITE_CTA_DESTINATION.RECEPTIONIST },
  {
    value: WEBSITE_CTA_DESTINATION.RECEPTIONIST_PRICING,
  },
  { value: WEBSITE_CTA_DESTINATION.BLOG },
  // Legacy tokens remain valid for saved links, but owners now choose their
  // own slide and session destinations instead of preset session shortcuts.
  { value: WEBSITE_CTA_DESTINATION.CONSULTATION_SESSION },
  { value: WEBSITE_CTA_DESTINATION.BOOKING },
] as const;

export type WebsiteCtaDestination = (typeof WEBSITE_CTA_DESTINATIONS)[number]["value"];

const WEBSITE_CTA_DESTINATION_VALUES = new Set<string>(
  WEBSITE_CTA_DESTINATIONS.map(({ value }) => value),
);

export function isFixedWebsiteCtaDestination(value: string): value is WebsiteCtaDestination {
  return WEBSITE_CTA_DESTINATION_VALUES.has(value);
}

export function isDynamicWebsiteCtaDestination(value: string): boolean {
  return /^(slide|campaign):\d+$/.test(value)
    || /^page:[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)
    || /^tab:(?:tab-\d+|current-offers|client-feedback|sessions)$/.test(value);
}

export function isSamePageWebsiteCtaDestination(value: string): boolean {
  return /^#[^\s#]+$/.test(value);
}

export function isInternalWebsiteCtaDestination(value: string): boolean {
  return isFixedWebsiteCtaDestination(value)
    || isDynamicWebsiteCtaDestination(value)
    || isSamePageWebsiteCtaDestination(value);
}